module.exports = __webpack_public_path__ + "static/media/file-word.07120a94.svg";